import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/sustaingrowth_v2.png';
import '../css/sg-header.css';
import { useAuth } from '../services/authContext';

const Header = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="header">
      <div className="logo-container-header">
        <img src={logo} alt="SustainGrowth" className="logo-header" />
      </div>
      <nav>
        <ul className="nav-links">
          <li>
            <Link to="../dashboard" className="nav-link">
              <i className="fa-solid fa-chart-line"></i>Dashboard
            </Link>
          </li>
          <li>
            <Link to="../pilares" className="nav-link">
              <i className="fa-solid fa-award"></i>Avaliações
            </Link>
          </li>
          <li>
            <Link to="../profile" className="nav-link">
              <i className="fa-regular fa-circle-user"></i>Perfil
            </Link>
          </li>
          <li>
            <Link to="../login" onClick={handleLogout} className="nav-link">
              <i className="fa-solid fa-power-off"></i>Sair
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
